// Home Zen · Social Kit content (IT / EN / ZH)
// Structure kept flat & scannable. All copy trilingual.

export const socialKitMeta = {
  it: {
    kicker: "Social Kit",
    title: "Il Social Kit di Home Zen.",
    subtitle:
      "Contenuti pronti da pubblicare per Instagram e TikTok — brand, prodotto e franchising. Copia, incolla, respira.",
    monthly: "12 post · 15 storie · 3 reel/TikTok",
    downloadPdf: "Scarica il kit in PDF",
    backHome: "Torna al sito",
    sections: {
      overview: "Panoramica",
      tone: "Tono di voce",
      pillars: "Pilastri di contenuto",
      posts: "Post Instagram",
      stories: "Storie",
      reels: "Reel / TikTok",
      calendar: "Calendario editoriale",
      hashtags: "Hashtag",
      design: "Linee grafiche",
    },
    labels: {
      caption: "Caption",
      hashtags: "Hashtag",
      cta: "Call-to-action",
      visual: "Visual",
      hook: "Hook",
      script: "Script",
      duration: "Durata",
      music: "Musica",
      format: "Formato",
      pillar: "Pilastro",
      copy: "Copia",
      copied: "Copiato",
      day: "Giorno",
      goal: "Obiettivo",
      sticker: "Sticker",
      dos: "Da fare",
      donts: "Da evitare",
      palette: "Palette",
      fonts: "Font",
      example: "Anteprima",
    },
    formats: {
      single: "Singolo",
      carousel: "Carosello",
      reels: "Reel",
      story: "Storia",
    },
  },
  en: {
    kicker: "Social Kit",
    title: "The Home Zen Social Kit.",
    subtitle:
      "Ready-to-post content for Instagram and TikTok — brand, product and franchise. Copy, paste, breathe.",
    monthly: "12 posts · 15 stories · 3 reels/TikToks",
    downloadPdf: "Download the kit as PDF",
    backHome: "Back to site",
    sections: {
      overview: "Overview",
      tone: "Tone of voice",
      pillars: "Content pillars",
      posts: "Instagram posts",
      stories: "Stories",
      reels: "Reels / TikTok",
      calendar: "Editorial calendar",
      hashtags: "Hashtags",
      design: "Design guidelines",
    },
    labels: {
      caption: "Caption",
      hashtags: "Hashtags",
      cta: "Call-to-action",
      visual: "Visual",
      hook: "Hook",
      script: "Script",
      duration: "Duration",
      music: "Music",
      format: "Format",
      pillar: "Pillar",
      copy: "Copy",
      copied: "Copied",
      day: "Day",
      goal: "Goal",
      sticker: "Sticker",
      dos: "Do",
      donts: "Don't",
      palette: "Palette",
      fonts: "Fonts",
      example: "Preview",
    },
    formats: {
      single: "Single",
      carousel: "Carousel",
      reels: "Reel",
      story: "Story",
    },
  },
  zh: {
    kicker: "社媒资料包",
    title: "Home Zen 社媒资料包。",
    subtitle:
      "Instagram 与 TikTok 即发内容 —— 涵盖品牌、产品与加盟。复制、粘贴、发布。",
    monthly: "12 条帖子 · 15 条 Story · 3 条 Reel / TikTok",
    downloadPdf: "下载 PDF 版",
    backHome: "返回首页",
    sections: {
      overview: "总览",
      tone: "品牌语调",
      pillars: "内容支柱",
      posts: "Instagram 帖子",
      stories: "Story",
      reels: "Reel / TikTok",
      calendar: "内容日历",
      hashtags: "话题标签",
      design: "视觉规范",
    },
    labels: {
      caption: "文案",
      hashtags: "话题标签",
      cta: "行动号召",
      visual: "视觉",
      hook: "开场钩子",
      script: "脚本",
      duration: "时长",
      music: "音乐",
      format: "形式",
      pillar: "支柱",
      copy: "复制",
      copied: "已复制",
      day: "第几天",
      goal: "目标",
      sticker: "贴纸",
      dos: "推荐",
      donts: "避免",
      palette: "色板",
      fonts: "字体",
      example: "预览",
    },
    formats: {
      single: "单图",
      carousel: "多图轮播",
      reels: "Reel",
      story: "Story",
    },
  },
};

export const brandTone = {
  it: {
    voice: [
      "Essenziale, mai freddo.",
      "Sensoriale: parliamo di materia, luce, silenzio.",
      "Colto senza ostentazione. Frasi brevi, ritmo lento.",
      "Prima persona plurale per il brand, seconda per il lettore.",
    ],
    keywords: ["vivere essenziale", "meno ma meglio", "materia naturale", "gesto quotidiano", "casa che respira"],
  },
  en: {
    voice: [
      "Essential, never cold.",
      "Sensory: we speak of matter, light, silence.",
      "Cultured without ostentation. Short sentences, slow rhythm.",
      "First-person plural for the brand, second for the reader.",
    ],
    keywords: ["essential living", "less but better", "natural matter", "daily ritual", "a home that breathes"],
  },
  zh: {
    voice: [
      "简约,但不冷淡。",
      "感官化:讲述质地、光与静。",
      "有涵养,不炫耀。短句,慢节奏。",
      "品牌以「我们」自称,受众以「您」称呼。",
    ],
    keywords: ["极简生活", "少即是多", "天然质地", "日常仪式", "会呼吸的家"],
  },
};

export const pillars = [
  {
    id: "brand",
    color: "#8B7355",
    icon: "Feather",
    name: { it: "Brand & Filosofia", en: "Brand & Philosophy", zh: "品牌与理念" },
    desc: {
      it: "Chi siamo, cosa crediamo, come guardiamo il mondo.",
      en: "Who we are, what we believe, how we see the world.",
      zh: "我们是谁,我们相信什么,我们如何看世界。",
    },
    weight: 25,
  },
  {
    id: "product",
    color: "#A39B8E",
    icon: "Package",
    name: { it: "Prodotto & Materia", en: "Product & Matter", zh: "产品与质地" },
    desc: {
      it: "Tessili, biancheria, complementi. Dettagli e cura.",
      en: "Textiles, linens, décor. Details and care.",
      zh: "纺织、床品、家居饰品。细节与用心。",
    },
    weight: 40,
  },
  {
    id: "franchise",
    color: "#1A1A1A",
    icon: "Storefront",
    name: { it: "Franchising & Community", en: "Franchise & Community", zh: "加盟与社群" },
    desc: {
      it: "Storie di affiliati, aperture, numeri, opportunità.",
      en: "Franchisee stories, openings, numbers, opportunities.",
      zh: "加盟商故事、新店开业、数据与机会。",
    },
    weight: 20,
  },
  {
    id: "ritual",
    color: "#C9B79C",
    icon: "Sun",
    name: { it: "Rituali & Lifestyle", en: "Rituals & Lifestyle", zh: "仪式与生活方式" },
    desc: {
      it: "Piccoli gesti che rendono la casa un rifugio.",
      en: "Small gestures that turn a home into a refuge.",
      zh: "让家成为庇护所的小小仪式。",
    },
    weight: 15,
  },
];

// 12 Instagram posts (mix of pillars, formats)
export const posts = [
  {
    id: "p01",
    pillar: "brand",
    format: "single",
    visual: {
      it: "Still life: lino grezzo piegato, luce laterale, ombra lunga.",
      en: "Still life: raw linen folded, side light, long shadow.",
      zh: "静物:折叠的原色亚麻,侧光,长影。",
    },
    caption: {
      it: "Meno, ma meglio.\n\nUna casa non ha bisogno di tutto. Ha bisogno di poche cose fatte bene.\nHome Zen nasce da qui: un vivere essenziale, che invecchia con grazia.",
      en: "Less, but better.\n\nA home doesn't need everything. It needs a few things done well.\nHome Zen begins here: essential living that ages with grace.",
      zh: "少即是多。\n\n家不需要拥有一切,只需拥有少而精。\nHome Zen 由此而生:极简生活,优雅陈化。",
    },
    cta: {
      it: "Scopri la nostra filosofia → link in bio",
      en: "Discover our philosophy → link in bio",
      zh: "了解我们的理念 → 主页链接",
    },
    hashtags: ["#HomeZen", "#VivereEssenziale", "#LessButBetter", "#SlowLiving", "#HomeDecor"],
  },
  {
    id: "p02",
    pillar: "product",
    format: "carousel",
    visual: {
      it: "5 slide: lino → cotone percalle → seta → viscosa di bamboo → ceramica. Macro texture.",
      en: "5 slides: linen → percale cotton → silk → bamboo viscose → ceramic. Macro texture.",
      zh: "五张连图:亚麻 → 珠地棉 → 真丝 → 竹纤维 → 陶瓷。微距纹理。",
    },
    caption: {
      it: "5 materie, un solo linguaggio: la calma.\n\n01 · Lino, la seconda pelle dell'estate.\n02 · Percalle, freschezza compatta.\n03 · Seta, per il gesto della notte.\n04 · Bamboo, morbidezza sostenibile.\n05 · Ceramica, la mano dell'artigiano.",
      en: "5 materials, one language: calm.\n\n01 · Linen, summer's second skin.\n02 · Percale, compact freshness.\n03 · Silk, for the night gesture.\n04 · Bamboo, sustainable softness.\n05 · Ceramic, the artisan's hand.",
      zh: "五种质地,一种语言:宁静。\n\n01 · 亚麻,夏日的第二层肌肤。\n02 · 珠地棉,紧致的清爽。\n03 · 真丝,夜的仪式。\n04 · 竹纤维,可持续的柔软。\n05 · 陶瓷,匠人之手。",
    },
    cta: {
      it: "Salva il post e passa in negozio.",
      en: "Save the post and visit the store.",
      zh: "收藏此贴,欢迎到店。",
    },
    hashtags: ["#HomeZen", "#Linen", "#NaturalMaterials", "#TextileLove", "#HomeTextile"],
  },
  {
    id: "p03",
    pillar: "franchise",
    format: "single",
    visual: {
      it: "Ritratto affiliato nel suo negozio, luce naturale, pose rilassata, brand a mano.",
      en: "Franchisee portrait in their store, natural light, relaxed pose, brand tag in hand.",
      zh: "加盟商在店内的肖像,自然光,放松姿态,手持品牌吊牌。",
    },
    caption: {
      it: "«Non avevo esperienza nel retail. Oggi il mio Home Zen è il punto di riferimento del quartiere.»\n— Giulia F., Affiliata · Bologna\n\nFormazione, marketing e centrale acquisti al tuo fianco. Ogni giorno.",
      en: "\"I had no retail experience. Today my Home Zen is the neighborhood's landmark.\"\n— Giulia F., Franchisee · Bologna\n\nTraining, marketing and central purchasing by your side. Every day.",
      zh: "「此前我毫无零售经验。如今,我的 Home Zen 已成为社区地标。」\n—— Giulia F.,加盟商 · 博洛尼亚\n\n培训、营销与集中采购,每日相伴。",
    },
    cta: {
      it: "Apri il tuo Home Zen → homezen.it/franchising",
      en: "Open your Home Zen → homezen.it/franchise",
      zh: "开启您的 Home Zen → homezen.it/franchise",
    },
    hashtags: ["#Franchising", "#Franchise", "#HomeZen", "#BusinessOpportunity", "#RetailItalia"],
  },
  {
    id: "p04",
    pillar: "ritual",
    format: "single",
    visual: {
      it: "Mano che rimbocca le lenzuola all'alba. Toni caldi. 4:5.",
      en: "Hand tucking sheets at dawn. Warm tones. 4:5.",
      zh: "破晓时分整理床单的手。暖色调。4:5。",
    },
    caption: {
      it: "Il primo gesto della giornata è già un rituale.\n\nLenzuola tese, luce che entra piano.\nUn minuto in più a letto vale di più di dieci a correre.",
      en: "The first gesture of the day is already a ritual.\n\nSmooth sheets, light entering slowly.\nOne extra minute in bed is worth more than ten spent running.",
      zh: "一天的第一个动作,便已是仪式。\n\n平整的床单,缓缓透入的晨光。\n多躺一分钟,胜过匆忙十分钟。",
    },
    cta: {
      it: "Salva per lunedì mattina.",
      en: "Save for Monday morning.",
      zh: "收藏,留给周一清晨。",
    },
    hashtags: ["#SlowMorning", "#HomeZen", "#BedLinen", "#DailyRitual", "#EssentialLiving"],
  },
  {
    id: "p05",
    pillar: "product",
    format: "carousel",
    visual: {
      it: "3 slide: divano beige con cuscini in lino, dettaglio piega, angolo living con vaso.",
      en: "3 slides: beige sofa with linen cushions, fold detail, living corner with vase.",
      zh: "三张连图:米色沙发配亚麻靠垫,褶皱细节,客厅一角与花瓶。",
    },
    caption: {
      it: "Un cuscino può cambiare una stanza.\n\nLino sabbia, imbottitura in piuma, misure sartoriali. Un dettaglio piccolo che rende una stanza più calma.\nDisponibile in negozio.",
      en: "A cushion can change a room.\n\nSand linen, feather filling, tailored measurements. A small detail that makes a room feel calmer.\nAvailable in store.",
      zh: "一只靠垫,足以改变一个空间。\n\n沙色亚麻,羽绒填充,量身定制。以细节让空间更宁静。\n门店现货。",
    },
    cta: {
      it: "Vieni a toccarli dal vivo.",
      en: "Come feel them in person.",
      zh: "欢迎到店亲手感受。",
    },
    hashtags: ["#HomeZen", "#Cushions", "#LinenLove", "#InteriorDesign", "#HomeInspo"],
  },
  {
    id: "p06",
    pillar: "brand",
    format: "carousel",
    visual: {
      it: "6 slide numerate 01–06: parole singole (Materia · Luce · Silenzio · Cura · Tempo · Casa) su fondo sabbia.",
      en: "6 numbered slides 01–06: single words (Matter · Light · Silence · Care · Time · Home) on sand background.",
      zh: "六张编号连图 01–06:单词(质地 · 光 · 静 · 用心 · 时间 · 家)于沙色背景。",
    },
    caption: {
      it: "Sei parole per capirci meglio.\n\nMateria. Luce. Silenzio. Cura. Tempo. Casa.\nSono i pilastri di ogni scelta Home Zen, dal filato alla vetrina.",
      en: "Six words to know us better.\n\nMatter. Light. Silence. Care. Time. Home.\nThe pillars of every Home Zen choice, from yarn to window.",
      zh: "六个词,让你更懂我们。\n\n质地。光。静。用心。时间。家。\n这是 Home Zen 每一次选择的支柱,从纱线到橱窗。",
    },
    cta: {
      it: "Con quale parola ti riconosci di più? Scrivilo nei commenti.",
      en: "Which word resonates with you? Tell us in the comments.",
      zh: "哪个词最打动你?评论区告诉我们。",
    },
    hashtags: ["#HomeZen", "#Manifesto", "#BrandStory", "#EssentialLiving"],
  },
  {
    id: "p07",
    pillar: "franchise",
    format: "carousel",
    visual: {
      it: "5 slide: numero grande '20 anni', '5.000 clienti', '98% soddisfazione', '80–120 mq', '48 ore per risposta'.",
      en: "5 slides: big number '20 years', '5,000 clients', '98% satisfaction', '80–120 sqm', '48-hour reply'.",
      zh: "五张连图:大字号 「20 年」「5,000 位顾客」「98% 满意度」「80–120 平米」「48 小时回复」。",
    },
    caption: {
      it: "Cinque numeri che parlano di fiducia.\n\n20 anni di esperienza.\n5.000+ clienti soddisfatti.\n98% di soddisfazione.\n80–120 mq: il formato del negozio.\n48 ore: il tempo in cui ti richiamiamo.",
      en: "Five numbers that speak of trust.\n\n20 years of experience.\n5,000+ happy customers.\n98% satisfaction.\n80–120 sqm: the store format.\n48 hours: how fast we reply.",
      zh: "五个数字,诠释信任。\n\n20 年经验。\n5,000+ 满意顾客。\n98% 满意度。\n80–120 平米:门店规格。\n48 小时:我们的回复时效。",
    },
    cta: {
      it: "Vuoi essere il prossimo numero? Link in bio.",
      en: "Want to be the next number? Link in bio.",
      zh: "愿意成为下一个数字?主页链接。",
    },
    hashtags: ["#Franchise", "#Franchising", "#BusinessGrowth", "#HomeZen", "#RetailOpportunity"],
  },
  {
    id: "p08",
    pillar: "product",
    format: "single",
    visual: {
      it: "Piatto in ceramica beige su tovaglia in lino, cucchiaio in legno, ombra morbida.",
      en: "Beige ceramic plate on linen tablecloth, wooden spoon, soft shadow.",
      zh: "米色陶瓷盘置于亚麻桌布之上,木勺,柔和阴影。",
    },
    caption: {
      it: "La tavola come piccolo teatro quotidiano.\n\nCeramica smaltata a mano, tovagliato in lino stone-washed, legno d'ulivo.\nMeno oggetti, più significato ad ogni pasto.",
      en: "The table as a small daily theatre.\n\nHand-glazed ceramic, stone-washed linen, olive wood.\nFewer objects, more meaning at every meal.",
      zh: "餐桌,是每日的小舞台。\n\n手工上釉陶瓷、水洗亚麻、橄榄木。\n餐具愈少,每一餐愈有意义。",
    },
    cta: {
      it: "Passa in negozio: apparecchiamo insieme.",
      en: "Visit the store: we'll set the table together.",
      zh: "欢迎到店:一起摆一桌。",
    },
    hashtags: ["#HomeZen", "#TableSetting", "#Ceramics", "#SlowLiving", "#HomeGoods"],
  },
  {
    id: "p09",
    pillar: "ritual",
    format: "single",
    visual: {
      it: "Bagno neutro: asciugamano in spugna beige piegato, sapone artigianale, ombra di foglia.",
      en: "Neutral bathroom: folded beige terry towel, artisan soap, leaf shadow.",
      zh: "中性色浴室:折叠的米色毛巾、手工皂、叶影。",
    },
    caption: {
      it: "Il rituale della sera comincia in bagno.\n\nSpugna 500 g/m², lino grezzo, sapone artigianale. Piccole cose che rallentano il tempo.\nBuone abitudini, ogni sera.",
      en: "The evening ritual begins in the bathroom.\n\n500 g/m² terry, raw linen, artisan soap. Small things that slow time down.\nGood habits, every night.",
      zh: "夜的仪式,从浴室开始。\n\n500 克/平方米毛巾,原色亚麻,手工皂。让时光慢下的小事。\n好的习惯,每一晚。",
    },
    cta: {
      it: "Salva per la tua sera.",
      en: "Save for your evening.",
      zh: "收藏,献给您的夜晚。",
    },
    hashtags: ["#HomeZen", "#EveningRitual", "#Bathroom", "#SelfCare", "#SlowLiving"],
  },
  {
    id: "p10",
    pillar: "franchise",
    format: "single",
    visual: {
      it: "Interno negozio Home Zen alle 7:00: luce dorata, vetrina, scaffalature ordinate.",
      en: "Home Zen store interior at 7:00 AM: golden light, window, tidy shelving.",
      zh: "清晨七点的 Home Zen 门店内:金色光线,橱窗,整齐货架。",
    },
    caption: {
      it: "Prima che si accendano le luci.\n\nUn negozio Home Zen è pensato al centimetro: vetrina, illuminazione, tessuti, ritmo dei prodotti. Nessun dettaglio è lasciato al caso.\nFormat 80–120 mq, cifre condivise dopo il primo colloquio.",
      en: "Before the lights come on.\n\nA Home Zen store is designed to the centimeter: window, lighting, textiles, product rhythm. Nothing is left to chance.\n80–120 sqm format, figures shared after the first call.",
      zh: "灯亮之前。\n\n一家 Home Zen 门店以厘米为单位精心设计:橱窗、灯光、织物、陈列节奏。无一细节被忽视。\n80–120 平米规格,首次沟通后分享具体数字。",
    },
    cta: {
      it: "Prenota una consulenza in bio.",
      en: "Book a consultation in bio.",
      zh: "主页预约咨询。",
    },
    hashtags: ["#Franchise", "#Retail", "#StoreDesign", "#HomeZen", "#BusinessOpportunity"],
  },
  {
    id: "p11",
    pillar: "product",
    format: "carousel",
    visual: {
      it: "4 slide: tende crema al vento, dettaglio orlo, gancio in ottone, camera con tenda che filtra la luce.",
      en: "4 slides: cream curtains in the wind, hem detail, brass hook, room with light-filtering curtain.",
      zh: "四张连图:米色窗帘随风摇曳,下摆细节,黄铜挂钩,窗帘滤光的房间。",
    },
    caption: {
      it: "La luce, se la lasci entrare piano, cambia la casa.\n\nTende in lino crema, orlo a giorno, ganci in ottone brunito. Filtrano il giorno, non lo chiudono.",
      en: "Light, if you let it in gently, changes a home.\n\nCream linen curtains, hemstitch, burnished brass hooks. They filter the day, they don't close it out.",
      zh: "让光缓缓入室,家便随之改变。\n\n米色亚麻窗帘,抽纱下摆,古铜色黄铜挂钩。滤光,而非遮光。",
    },
    cta: {
      it: "Prendi le misure e passa da noi.",
      en: "Take measurements and drop by.",
      zh: "量好尺寸,欢迎到店。",
    },
    hashtags: ["#HomeZen", "#Curtains", "#LinenCurtains", "#InteriorDesign", "#SlowHome"],
  },
  {
    id: "p12",
    pillar: "brand",
    format: "single",
    visual: {
      it: "Logo Home Zen in oro brunito su fondo sabbia. Minimalismo assoluto.",
      en: "Home Zen logo in burnished gold on sand background. Absolute minimalism.",
      zh: "沙色底上的古铜金色 Home Zen 标识。极简至上。",
    },
    caption: {
      it: "Home Zen.\nIl vivere essenziale, in franchising.\n\nGrazie a chi ci ha scelto in questo mese.\nA chi ci scoprirà il prossimo: benvenuto.",
      en: "Home Zen.\nEssential living, in franchise.\n\nThank you to those who chose us this month.\nTo those who will discover us next: welcome.",
      zh: "Home Zen。\n极简生活,特许经营。\n\n感谢本月选择我们的每一位。\n欢迎将在下月发现我们的您。",
    },
    cta: {
      it: "Un mese, insieme.",
      en: "One month, together.",
      zh: "一个月,一起走过。",
    },
    hashtags: ["#HomeZen", "#Community", "#BrandLove", "#EssentialLiving"],
  },
];

// 15 Stories (9:16, short & tactical)
export const stories = [
  {
    id: "s01",
    goal: { it: "Warm welcome", en: "Warm welcome", zh: "温暖问候" },
    sticker: "text",
    copy: {
      it: "Buongiorno.\nBenvenuti in una nuova settimana in Home Zen. ☁️",
      en: "Good morning.\nWelcome to a new week at Home Zen. ☁️",
      zh: "早安。\n欢迎迈入 Home Zen 的新一周。☁️",
    },
  },
  {
    id: "s02",
    goal: { it: "Behind the scenes", en: "Behind the scenes", zh: "幕后花絮" },
    sticker: "location",
    copy: {
      it: "Nuovi arrivi in magazzino.\nApriamo insieme? 📦",
      en: "New arrivals in the warehouse.\nShall we unbox together? 📦",
      zh: "仓库刚到新品。\n一起拆箱?📦",
    },
  },
  {
    id: "s03",
    goal: { it: "Poll (engagement)", en: "Poll (engagement)", zh: "投票 · 互动" },
    sticker: "poll",
    copy: {
      it: "Lenzuola perfette:\nA · Lino grezzo\nB · Percalle croccante",
      en: "Perfect sheets:\nA · Raw linen\nB · Crisp percale",
      zh: "完美床品:\nA · 原色亚麻\nB · 珠地棉",
    },
  },
  {
    id: "s04",
    goal: { it: "Product close-up", en: "Product close-up", zh: "产品特写" },
    sticker: "product-tag",
    copy: {
      it: "Il dettaglio che cambia tutto:\ncucitura a giorno, fatta a mano.",
      en: "The detail that changes everything:\nhemstitch, done by hand.",
      zh: "改变一切的细节:\n手工抽纱下摆。",
    },
  },
  {
    id: "s05",
    goal: { it: "Quote card", en: "Quote card", zh: "金句卡片" },
    sticker: "text",
    copy: {
      it: "«La bellezza è ciò che resta\nquando togli il superfluo.»",
      en: "\"Beauty is what remains\nwhen you remove the superfluous.\"",
      zh: "「美,是移除多余之后所留下的一切。」",
    },
  },
  {
    id: "s06",
    goal: { it: "In-store CTA", en: "In-store CTA", zh: "到店引流" },
    sticker: "swipe-up",
    copy: {
      it: "Siamo aperti oggi\n10:00 – 19:30\nLacchiarella (MI)",
      en: "Open today\n10:00 – 19:30\nLacchiarella (MI)",
      zh: "今日营业\n10:00 – 19:30\n拉基亚雷拉(米兰)",
    },
  },
  {
    id: "s07",
    goal: { it: "Franchise teaser", en: "Franchise teaser", zh: "加盟预告" },
    sticker: "link",
    copy: {
      it: "Vuoi aprire il tuo Home Zen?\nRichiedi info · link in bio",
      en: "Open your Home Zen?\nRequest info · link in bio",
      zh: "想开一家 Home Zen?\n主页链接咨询详情",
    },
  },
  {
    id: "s08",
    goal: { it: "Question sticker", en: "Question sticker", zh: "提问贴纸" },
    sticker: "question",
    copy: {
      it: "Qual è la tua stanza preferita?\n(Scrivilo qui 👇)",
      en: "What's your favorite room?\n(Write it here 👇)",
      zh: "你最喜欢家里的哪个房间?\n(写在下方 👇)",
    },
  },
  {
    id: "s09",
    goal: { it: "Ritual moment", en: "Ritual moment", zh: "仪式时刻" },
    sticker: "text",
    copy: {
      it: "Tè caldo.\nCandela accesa.\nNiente notifiche.",
      en: "Warm tea.\nCandle lit.\nNo notifications.",
      zh: "一杯热茶。\n一支蜡烛。\n无通知打扰。",
    },
  },
  {
    id: "s10",
    goal: { it: "Countdown to opening", en: "Countdown to opening", zh: "开业倒计时" },
    sticker: "countdown",
    copy: {
      it: "-3 giorni al nuovo Home Zen di Verona.\nCi vediamo lì? 🌿",
      en: "-3 days to the new Home Zen in Verona.\nSee you there? 🌿",
      zh: "距 Home Zen 维罗纳新店 3 天。\n到时候见?🌿",
    },
  },
  {
    id: "s11",
    goal: { it: "Repost affiliate", en: "Repost franchisee", zh: "转发加盟商" },
    sticker: "mention",
    copy: {
      it: "Grazie @homezen_bologna\nper questa vetrina 🤍",
      en: "Thank you @homezen_bologna\nfor this window display 🤍",
      zh: "感谢 @homezen_bologna\n带来的橱窗 🤍",
    },
  },
  {
    id: "s12",
    goal: { it: "Care tip", en: "Care tip", zh: "养护小贴士" },
    sticker: "text",
    copy: {
      it: "Cura del lino:\nlavaggio 30°, no ammorbidente,\nstiro leggermente umido.",
      en: "Linen care:\nwash 30°C, no softener,\niron slightly damp.",
      zh: "亚麻养护:\n30° 水洗,勿用柔顺剂,\n微湿熨烫。",
    },
  },
  {
    id: "s13",
    goal: { it: "Quiz", en: "Quiz", zh: "小测验" },
    sticker: "quiz",
    copy: {
      it: "Quante ore passiamo a letto in una vita?\nA · 20% B · 33% C · 50%",
      en: "How many hours do we spend in bed in a lifetime?\nA · 20% B · 33% C · 50%",
      zh: "一生中我们在床上度过多少时间?\nA · 20% B · 33% C · 50%",
    },
  },
  {
    id: "s14",
    goal: { it: "Social proof", en: "Social proof", zh: "口碑引用" },
    sticker: "text",
    copy: {
      it: "★★★★★\n«Un negozio in cui vorresti abitare.»\n— Marta, Lodi",
      en: "★★★★★\n\"A store you'd want to live in.\"\n— Marta, Lodi",
      zh: "★★★★★\n「想住进这家店。」\n—— Marta,洛迪",
    },
  },
  {
    id: "s15",
    goal: { it: "Sunday soft CTA", en: "Sunday soft CTA", zh: "周日温柔号召" },
    sticker: "sticker-mixed",
    copy: {
      it: "Buona domenica lenta.\nSalvate le storie preferite? 🤍",
      en: "Happy slow Sunday.\nSaved your favorite stories? 🤍",
      zh: "周日,慢慢来。\n收藏了喜欢的 Story 吗?🤍",
    },
  },
];

// 3 Reels / TikTok scripts
export const reels = [
  {
    id: "r01",
    duration: "30s",
    format: "9:16",
    music: {
      it: "Ambient piano lento (mood calmo, no drop).",
      en: "Slow ambient piano (calm mood, no drop).",
      zh: "缓慢的氛围钢琴(平和,无爆点)。",
    },
    hook: {
      it: "«Cosa succede in un negozio Home Zen alle 7:00 del mattino?»",
      en: "\"What happens in a Home Zen store at 7:00 AM?\"",
      zh: "「早上七点的 Home Zen 门店里,发生着什么?」",
    },
    script: [
      {
        t: "0–3s",
        cue: {
          it: "Vetrina esterna, luce dorata. Testo overlay: 07:00.",
          en: "Storefront outside, golden light. Overlay text: 07:00.",
          zh: "店外橱窗,金色晨光。字幕:07:00。",
        },
      },
      {
        t: "3–10s",
        cue: {
          it: "Interno vuoto. Mano che apre le tende. Prodotti che appaiono in sequenza (jump cut lenti).",
          en: "Empty interior. A hand opens the curtains. Products appear in sequence (slow jump cuts).",
          zh: "空店内景。手拉开窗帘。产品依次出现(慢速跳切)。",
        },
      },
      {
        t: "10–18s",
        cue: {
          it: "Piegatura di lenzuola, disposizione cuscini, ceramica sul tavolo. Micro dettagli.",
          en: "Folding sheets, arranging cushions, ceramics on the table. Micro-details.",
          zh: "整理床单,摆放靠垫,桌上陈列陶瓷。微观细节。",
        },
      },
      {
        t: "18–24s",
        cue: {
          it: "Volto sorridente dell'affiliato che apre la porta. Testo: 'Buongiorno.'",
          en: "Franchisee's smile as they unlock the door. Text: 'Good morning.'",
          zh: "加盟商开门微笑。字幕:「早安。」",
        },
      },
      {
        t: "24–30s",
        cue: {
          it: "Logo Home Zen + CTA testuale: 'Apri il tuo — homezen.it'",
          en: "Home Zen logo + text CTA: 'Open yours — homezen.it'",
          zh: "Home Zen 标识 + 字幕:「开启您的 — homezen.it」",
        },
      },
    ],
    caption: {
      it: "Ogni giorno comincia con un piccolo rito. Il nostro comincia alle 7. 🌿\nVuoi aprire il tuo Home Zen? Link in bio.",
      en: "Every day begins with a small ritual. Ours begins at 7. 🌿\nWant to open your Home Zen? Link in bio.",
      zh: "每一天,都从一个小小的仪式开始。我们的仪式,从早晨七点开始。🌿\n想开一家 Home Zen?主页链接。",
    },
    hashtags: ["#HomeZen", "#Franchise", "#SlowMorning", "#RetailLife", "#BehindTheScenes"],
  },
  {
    id: "r02",
    duration: "20s",
    format: "9:16",
    music: {
      it: "Beat lo-fi caldo, ritmo di piegatura.",
      en: "Warm lo-fi beat, folding rhythm.",
      zh: "温暖的 lo-fi 节拍,配合折叠节奏。",
    },
    hook: {
      it: "«3 modi per piegare un asciugamano in stile Home Zen.»",
      en: "\"3 ways to fold a towel, Home Zen style.\"",
      zh: "「Home Zen 风格 · 折毛巾的三种方式。」",
    },
    script: [
      {
        t: "0–2s",
        cue: {
          it: "Sfondo sabbia. Testo grande: '3 modi.'",
          en: "Sand background. Big text: '3 ways.'",
          zh: "沙色背景。大字号:「三种方式。」",
        },
      },
      {
        t: "2–8s",
        cue: {
          it: "Piegatura n.1 (rullo compatto). Testo: 01 · Il rullo.",
          en: "Fold no.1 (compact roll). Text: 01 · The Roll.",
          zh: "折法一(紧致卷筒)。字幕:01 · 卷筒。",
        },
      },
      {
        t: "8–14s",
        cue: {
          it: "Piegatura n.2 (in tre, gancetto visibile). Testo: 02 · Il triplo.",
          en: "Fold no.2 (thirds, hook visible). Text: 02 · The Third.",
          zh: "折法二(三折,挂环外露)。字幕:02 · 三折。",
        },
      },
      {
        t: "14–18s",
        cue: {
          it: "Piegatura n.3 (a piramide su scaffale). Testo: 03 · La piramide.",
          en: "Fold no.3 (pyramid on shelf). Text: 03 · The Pyramid.",
          zh: "折法三(架上金字塔)。字幕:03 · 金字塔。",
        },
      },
      {
        t: "18–20s",
        cue: {
          it: "Logo + CTA: 'Passa in negozio: te li mostriamo dal vivo.'",
          en: "Logo + CTA: 'Visit the store: we'll show you live.'",
          zh: "标识 + 字幕:「欢迎到店,现场演示。」",
        },
      },
    ],
    caption: {
      it: "Salva questo Reel: ti servirà a ogni cambio stagione.\n3 modi per piegare un asciugamano — stile Home Zen.",
      en: "Save this Reel: you'll use it every season.\n3 ways to fold a towel — Home Zen style.",
      zh: "收藏这条 Reel:每个换季都用得上。\n三种折毛巾的方式 —— Home Zen 风格。",
    },
    hashtags: ["#HomeZen", "#HomeHacks", "#TowelFold", "#Organizing", "#SlowHome"],
  },
  {
    id: "r03",
    duration: "45s",
    format: "9:16",
    music: {
      it: "Colonna sonora cinematografica soft (crescendo minimo).",
      en: "Soft cinematic score (minimal build).",
      zh: "轻柔电影配乐(极简递进)。",
    },
    hook: {
      it: "«Ho aperto un negozio senza esperienza. Ecco cos'è cambiato in 12 mesi.»",
      en: "\"I opened a store with no experience. Here's what changed in 12 months.\"",
      zh: "「我毫无经验地开了一家店。12 个月内,变化如下。」",
    },
    script: [
      {
        t: "0–4s",
        cue: {
          it: "Affiliata a mezzo busto, sguardo in camera. Testo: '12 mesi fa.'",
          en: "Franchisee mid-shot, looking at camera. Text: '12 months ago.'",
          zh: "加盟商半身镜头,直视镜头。字幕:「12 个月前。」",
        },
      },
      {
        t: "4–15s",
        cue: {
          it: "B-roll: firma contratto, formazione, allestimento vetrina, primo cliente.",
          en: "B-roll: signing contract, training, window setup, first customer.",
          zh: "B-roll:签合同、培训、布置橱窗、首位顾客。",
        },
      },
      {
        t: "15–28s",
        cue: {
          it: "Voice-over: «Non sapevo nulla. La centrale acquisti, la formazione, il marketing: c'era tutto.»",
          en: "Voice-over: \"I knew nothing. Central purchasing, training, marketing: it was all there.\"",
          zh: "旁白:「我一无所知。集中采购、培训、市场营销:一应俱全。」",
        },
      },
      {
        t: "28–38s",
        cue: {
          it: "Dati animati: '+ 32% clienti', 'break-even in 9 mesi', '4.8/5 recensioni'.",
          en: "Animated data: '+ 32% customers', 'break-even in 9 months', '4.8/5 reviews'.",
          zh: "动态数据:「+ 32% 顾客」「9 个月回本」「4.8/5 好评」。",
        },
      },
      {
        t: "38–45s",
        cue: {
          it: "Ritratto sorriso. Logo + CTA: 'Il prossimo può essere il tuo.'",
          en: "Smiling portrait. Logo + CTA: 'The next one could be yours.'",
          zh: "微笑肖像。标识 + 字幕:「下一家,可能就是您的。」",
        },
      },
    ],
    caption: {
      it: "Storia vera di un'affiliata Home Zen.\nSe ti sei mai chiesto se sia possibile: sì, lo è.\nRichiedi informazioni → link in bio.",
      en: "A real Home Zen franchisee story.\nIf you've ever wondered if it's possible: yes, it is.\nRequest info → link in bio.",
      zh: "一位真实 Home Zen 加盟商的故事。\n如果您在犹豫是否可行:是的,完全可行。\n主页链接咨询详情。",
    },
    hashtags: ["#Franchise", "#Franchising", "#SuccessStory", "#HomeZen", "#OwnYourStore"],
  },
];

// Editorial calendar (30 days, Mon-Sun cycle)
export const calendar = [
  { day: 1, type: "post", ref: "p01" },
  { day: 2, type: "story", ref: "s01" },
  { day: 3, type: "post", ref: "p02" },
  { day: 3, type: "story", ref: "s02" },
  { day: 5, type: "reel", ref: "r02" },
  { day: 6, type: "story", ref: "s03" },
  { day: 7, type: "post", ref: "p03" },
  { day: 8, type: "story", ref: "s04" },
  { day: 9, type: "post", ref: "p04" },
  { day: 10, type: "story", ref: "s05" },
  { day: 12, type: "post", ref: "p05" },
  { day: 12, type: "story", ref: "s06" },
  { day: 14, type: "reel", ref: "r01" },
  { day: 15, type: "post", ref: "p06" },
  { day: 16, type: "story", ref: "s07" },
  { day: 17, type: "post", ref: "p07" },
  { day: 18, type: "story", ref: "s08" },
  { day: 19, type: "post", ref: "p08" },
  { day: 20, type: "story", ref: "s09" },
  { day: 21, type: "story", ref: "s10" },
  { day: 22, type: "post", ref: "p09" },
  { day: 23, type: "story", ref: "s11" },
  { day: 24, type: "post", ref: "p10" },
  { day: 25, type: "story", ref: "s12" },
  { day: 26, type: "reel", ref: "r03" },
  { day: 27, type: "post", ref: "p11" },
  { day: 27, type: "story", ref: "s13" },
  { day: 28, type: "story", ref: "s14" },
  { day: 30, type: "post", ref: "p12" },
  { day: 30, type: "story", ref: "s15" },
];

// Hashtag bank
export const hashtagBank = {
  brand: ["#HomeZen", "#EssentialLiving", "#VivereEssenziale", "#LessButBetter", "#SlowLiving"],
  product: ["#LinenLove", "#NaturalMaterials", "#HomeTextile", "#BedLinen", "#Ceramics", "#TableSetting"],
  franchise: ["#Franchise", "#Franchising", "#RetailItalia", "#BusinessOpportunity", "#OwnYourStore"],
  ritual: ["#SlowMorning", "#DailyRitual", "#SelfCare", "#SundaySlow", "#HomeInspo"],
  discover: ["#InteriorDesign", "#HomeDecor", "#MinimalHome", "#SlowHome", "#WabiSabi"],
};

// Design guidelines
export const design = {
  palette: [
    { name: { it: "Bianco Caldo", en: "Warm White", zh: "暖白" }, hex: "#FAFAF7" },
    { name: { it: "Sabbia", en: "Sand", zh: "沙色" }, hex: "#F3EFEA" },
    { name: { it: "Tortora", en: "Taupe", zh: "灰褐" }, hex: "#A39B8E" },
    { name: { it: "Legno", en: "Wood", zh: "木色" }, hex: "#8B7355" },
    { name: { it: "Nero Opaco", en: "Matte Black", zh: "哑光黑" }, hex: "#1A1A1A" },
  ],
  fonts: [
    { name: "Cormorant Garamond", use: { it: "Titoli, citazioni", en: "Titles, quotes", zh: "标题、引用" } },
    { name: "Outfit", use: { it: "Testo, caption", en: "Body, captions", zh: "正文、文案" } },
  ],
  dos: {
    it: [
      "Lascia respirare i post: 40% area vuota minima.",
      "Usa luce naturale, ombre morbide, angoli reali.",
      "Fotografia orizzontale? Ricomponi in 4:5 per feed.",
      "Coerenza cromatica: mai più di due tonalità dominanti per post.",
    ],
    en: [
      "Let posts breathe: at least 40% negative space.",
      "Use natural light, soft shadows, real corners.",
      "Horizontal photo? Recompose in 4:5 for feed.",
      "Color coherence: no more than two dominant tones per post.",
    ],
    zh: [
      "让画面呼吸:至少 40% 留白。",
      "使用自然光、柔和阴影、真实空间。",
      "横幅照片?为 Feed 重新裁剪为 4:5。",
      "色彩一致:每贴最多两种主色调。",
    ],
  },
  donts: {
    it: [
      "Niente filtri saturi, niente HDR aggressivo.",
      "Vietato mixare più di 3 font in una grafica.",
      "No emoji nei titoli dei post, sì (con parsimonia) nelle caption.",
      "Mai testo bianco su sabbia senza ombra: illeggibile.",
    ],
    en: [
      "No saturated filters, no aggressive HDR.",
      "Don't mix more than 3 fonts in a graphic.",
      "No emoji in post titles, yes (sparingly) in captions.",
      "Never white text on sand without shadow: unreadable.",
    ],
    zh: [
      "禁用高饱和滤镜与强烈 HDR。",
      "单张图形不超过三种字体。",
      "标题不加 emoji,文案可少量使用。",
      "沙色底禁用无阴影白字:难以辨识。",
    ],
  },
};
